export const GET_USERS = 'getUsers'
export const GET_USER = 'getUser'
export const CHECK_USER = 'checkUser'
export const CREATE_USER = 'createUser'
export const UPDATE_USER = 'updateUser'
export const GET_STATUSES = 'getStatuses'
export const UPDATE_USER_PROFILE = 'updateUserProfile'
export const UPDATE_SUBSCRIPTIONS = 'updateSubscriptions'
export const SIGN_UP_CLIENT = 'signUpClient'

export const GET_ADMIN_DELIVERY_COMPANIES = 'getAdminDeliveryCompanies'
